<template>
  <b-modal id="modalVisitsOverview" size="xl" ref="modalVisitsOverview" @hide="onHide" hide-footer>
    <div slot="modal-title" v-translate>Visits Overview</div>
    <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>

    <b-row v-if="modalData && modalData.type === 'tour' && modalData.data">
      <b-col cols="6">
        <p class="bg-secondary text-center text-white m-0 p-2" v-if="modalData.data.commissionRaw !== 0" v-translate="{commission: modalData.data.commission}" render-html="true">Profit <strong>%{commission}</strong></p>
        <p class="card-benefit bg-dark text-center text-white m-0 p-2" v-else v-translate>Self Tour</p>
        <mapbox-static-map :markers="
          modalData.data.visits4Show.map((x, index) => {
            return {
              icon: 'pin-s-' + (index + 1) + '+fc0',
              lat: x.lat || null,
              lng: x.lng || null
            }
          })" class="card-img-top mb-3" v-if="!modalData.data.courier">
        </mapbox-static-map>

        <tour-map
          :tour-ids="[modalData.data.id]"
          with-tracking
          popup-type="shipping"
          class="mb-3"
          style="width: 100%; height: 412px"
          :handlers="[]"
          with-courier
          update-every="30"
          v-else
        />

        <div class="mb-4">
          <div class="tags align-self-center bg-white" v-if="modalData.data.tags && modalData.data.tags.length > 0" style="margin-top: -10px; border-radius: 2.25rem !important; padding: 5px;">
            <span class="d-inline-block bg-secondary rounded-circle p-2 mr-1" style="vertical-align: middle;">
              <font-awesome-icon icon="star" class="fa-inverse" style="color: #fff" size="2x" />
            </span>
            <span class="big d-inline-block" v-for="(item, index) in modalData.data.tags" :key="index">
              <b-badge variant="danger">{{ item.name }}</b-badge>&nbsp;
            </span>
          </div>
          <h6 class="mb-0">
            <span v-translate="{tourId: $options.filters.uuid(modalData.data.id)}" v-if="!modalData.data.isShared">
              Tour <strong>%{tourId}</strong>
            </span>
            <span v-else v-translate><strong>Shared</strong> Tour</span>
            <b-badge variant="success">{{modalData.data.status}}</b-badge>
          </h6>
          <b-badge pill variant="dark" v-translate="{visitsCount: modalData.data.visits4Show.length}">%{visitsCount} visits</b-badge>
          <b-badge v-for="(value, index) in modalData.data.sizes" :key="index" pill variant="warning" class="mr-1">
            {{index}}×{{value}}
          </b-badge>
          <hr class="my-1">
          <span v-translate="{startAddress: modalData.data.visits[0].address_name}"><strong>Start at</strong> %{startAddress}</span><hr class="my-1">
          <span v-translate="{endAddress: modalData.data.visits[modalData.data.visits.length - 1].address_name}"><strong>End at</strong> %{endAddress}</span><hr class="my-1">
          <span v-translate="{shippingDistance: distance(modalData.data.total_distance * 1000)}">Distance (aprox.) <strong>%{shippingDistance}</strong></span>
          <div v-if="!!baseData && !!baseData.lat">
            <hr class="my-1">
            <span v-translate="{toOrigin: distance(modalData.data.distance)}">To origin <strong>%{toOrigin}</strong></span>
          </div>
        </div>
        <b-card v-for="(visit, index) in modalData.data.visits4Show" :key="index" :class="visit.visited === 1 ? 'bg-success text-light' : ''">
          <b-row>
            <b-col cols="1">
              <h1>{{index + 1}}</h1>
            </b-col>
            <b-col cols="11">
              <p>
                <span
                  v-translate="{type: $gettext(visit.type), n: visit.shipping_ids.length}"
                  :translate-n="visit.shipping_ids.length"
                  translate-plural="Type: <strong>%{type} multiple (%{n} shippings)</strong>"
                  >Type: <strong>%{type}</strong><span class="d-none">%{n}</span></span><br>
                <span v-translate="{address: visit.address_name}">Address: <strong>%{address}</strong></span>
                <!-- allShippings logic removed as it was not in map_new.vue and depends on allShippings which we don't have here easily -->
              </p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6" v-if="!modalData.data.courier">
        <h3 v-show="assignList.length > 0" v-translate>Assign to:</h3>
        <h3 v-show="assignList.length === 0" v-translate>There are no couriers online</h3>
        <b-card v-for="(courier, index) in assignList" :key="index">
          <div class="row m-0">
            <div class="col-2 pl-0">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 60px; height: 60px; background-image: url(' + (courier.user.profile_picture || 'https://www.gravatar.com/avatar/default?s=60&r=pg&d=mm') + ')'" />
            </div>
            <div class="align-self-center col pr-0">
              <h6>{{courier.user.name}}</h6>
              <p class="m-0">
                <a :href="'mailto:' + courier.user.email"><strong>{{courier.user.email}}</strong></a><br>
                <a :href="'tel:' + courier.user.phone"><strong>{{courier.user.phone}}</strong></a>
              </p>
              <span v-translate="{toOrigin: distance(courier.distance)}">To origin <strong>%{toOrigin}</strong></span>
            </div>
            <div class="align-self-center text-lg-right col pr-lg-0 p-0">
              <b-button size="sm" variant="primary" @click.prevent="assignCourier(modalData, courier)">
                  <translate>Assign</translate>
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col cols="6" v-else>
        <h3 v-translate>Assigned to:</h3>
        <user-card :user="modalData.data.courier" />
        <div class="text-center">
          <hr>
          <b-button size="sm" variant="primary" :to="{name: 'ToursEdit', params: {id: modalData.data.id}}" target="_blank" v-translate>
            Manage Tour
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="modalData && modalData.type === 'shipping' && modalData.data">
      <b-col cols="6">
        <p class="bg-secondary text-center text-white m-0 p-2" v-if="modalData.data.commissionRaw !== 0" v-translate="{commission: modalData.data.commission}" render-html="true">Profit <strong>%{commission}</strong></p>
        <p class="card-benefit bg-dark text-center text-white m-0 p-2" v-else v-translate>Self Shipment</p>
        <mapbox-static-map :markers="[{
            icon: 'pin-s-a+900',
            lat: modalData.data.from_lat || null,
            lng: modalData.data.from_lng || null
          },
          {
            icon: 'pin-s-b+090',
            lat: modalData.data.to_lat || null,
            lng: modalData.data.to_lng || null
          }]" class="card-img-top mb-3" v-if="!modalData.data.courier">
        </mapbox-static-map>

        <shipping-map
          :shipping-id="modalData.data.shipping.id"
          without-button
          with-tracking
          class="mb-3"
          style="width: 100%; height: 412px"
          update-every="30"
          v-else
        />

        <div class="tags align-self-center bg-warning" v-if="modalData.data.is_back_and_forth" style="margin: -10px 0 20px 0; border-radius: 2.25rem 0 0 2.25rem !important; padding: 5px;">
          <span class="d-inline-block bg-white rounded-circle p-2 mr-1" style="vertical-align: middle;">
            <font-awesome-icon icon="exchange-alt" size="2x" />
          </span>
          <span class="big d-inline-block">
            <b-badge variant="light" v-translate>Roundtrip</b-badge>
          </span>
        </div>
        <div class="mb-4">
          <div class="tags align-self-center bg-white" v-if="modalData.data.tags && modalData.data.tags.length > 0" style="margin-top: -10px; border-radius: 2.25rem !important; padding: 5px;">
            <span class="d-inline-block bg-primary rounded-circle p-2 mr-1" style="vertical-align: middle;">
              <font-awesome-icon icon="star" class="fa-inverse" style="color: #fff" size="2x" />
            </span>
            <span class="big d-inline-block" v-for="(item, index) in modalData.data.tags" :key="index">
              <b-badge variant="danger">{{ item.name }}</b-badge>&nbsp;
            </span>
          </div>
          <h6 class="mb-0">
            <span v-translate="{shippingId: $options.filters.uuid(modalData.data.id)}" v-if="!modalData.data.isShared">
              Shipment <strong>%{shippingId}</strong>
            </span>
            <span v-else v-translate><strong>Shared</strong> Shipment</span>
            <b-badge variant="success">{{modalData.data.status}}</b-badge>
          </h6>
          <b-badge pill variant="dark">{{modalData.data.type}}</b-badge>
          <b-badge pill variant="warning">{{modalData.data.size}}</b-badge>
          <hr class="my-1">
          <div v-if="ecosystemModules.items.self && modalData.data.items.length > 0">
            <h4>{{ecosystemModules.items.label || $gettext('Items')}} <b-badge variant="dark">{{modalData.data.items[0].reference_code | cleanentityprefix}}</b-badge></h4>
            <hr class="my-1">
          </div>
          <shipping-checkpoint-micro :shipping="modalData.data" checkpoint="from" inline with-checkpoint-name></shipping-checkpoint-micro>
          <hr class="my-1">
          <div v-show="modalData.data.from_meta">
            <div style="height: auto; max-height: 100px; overflow-y: scroll;">
              <strong v-translate>Instructions (origin)</strong> <span v-html="$options.filters.brize(modalData.data.from_meta)"></span>
            </div>
            <hr class="my-1">
          </div>
          <shipping-checkpoint-micro :shipping="modalData.data" checkpoint="to" inline with-checkpoint-name></shipping-checkpoint-micro>
          <hr class="my-1">
          <div v-show="modalData.data.to_meta">
            <div style="height: auto; max-height: 100px; overflow-y: scroll;">
              <strong v-translate>Instructions (destination)</strong> <span v-html="$options.filters.brize(modalData.data.to_meta)"></span>
            </div>
            <hr class="my-1">
          </div>
          <span v-translate="{shippingDistance: distance(modalData.data.total_distance)}">Distance (aprox.) <strong>%{shippingDistance}</strong></span>
          <div v-if="!!baseData && !!baseData.lat">
            <hr class="my-1">
            <span v-translate="{toOrigin: distance(modalData.data.distance)}">To origin <strong>%{toOrigin}</strong></span>
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <div v-if="modalData.data.threads && modalData.data.threads.some(x => x.type === 'internal')">
          <h3 v-translate>Shipment Message Thread</h3>
          <shipping-message-threads :the-thread="modalData.data.threads.find(x => x.type === 'internal')" no-form no-subject />
        </div>
        <div v-if="!modalData.data.courier">
          <h3 v-show="assignList.length > 0" v-translate>Assign to:</h3>
          <h3 v-show="assignList.length === 0" v-translate>There are no couriers online</h3>
          <b-card v-for="(courier, index) in assignList" :key="index">
            <div class="row m-0 text-center text-lg-left">
              <div class="col-12 col-lg-3 col-xl-2 pl-lg-0 p-0">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 60px; height: 60px; background-image: url(' + (courier.user.profile_picture || 'https://www.gravatar.com/avatar/default?s=60&r=pg&d=mm') + ')'" />
              </div>
              <div class="align-self-center col pr-lg-0 p-0">
                <h6>{{courier.user.name}}</h6>
                <p class="m-0">
                  <a :href="'mailto:' + courier.user.email"><strong>{{courier.user.email}}</strong></a><br>
                  <a :href="'tel:' + courier.user.phone"><strong>{{courier.user.phone}}</strong></a>
                </p>
                <span v-translate="{toOrigin: distance(courier.distance)}">To origin <strong>%{toOrigin}</strong></span>
              </div>
              <div class="align-self-center text-lg-right col pr-lg-0 p-0">
                <b-button size="sm" variant="primary" @click.prevent="assignCourier(modalData, courier)">
                  <translate>Assign</translate>
                </b-button>
              </div>
            </div>
          </b-card>
        </div>
        <div v-else>
          <h3 v-translate>Assigned to:</h3>
          <user-card :user="modalData.data.courier" />
          <div class="text-center">
            <hr>
            <b-button size="sm" variant="primary" :to="{name: 'ShippingsEdit', params: {id: modalData.data.id}}" target="_blank" v-translate>
              Manage Shipment
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import MapboxStaticMap from '@/components/Maps/MapboxStaticMap'
import ShippingMap from '@/components/Maps/ShippingMap'
import TourMap from '@/components/Maps/TourMap'
import ShippingCheckpointMicro from '@/components/Shippings/CheckpointMicro'
import ShippingMessageThreads from '@/components/Shippings/MessageThreads'
import { icon } from '@fortawesome/fontawesome-svg-core'
import { faCloudRain } from '@fortawesome/free-solid-svg-icons'

export default {
  emits: ['assigned'],
  name: 'VisitsOverview',
  components: {
    MapboxStaticMap,
    ShippingMap,
    TourMap,
    ShippingCheckpointMicro,
    ShippingMessageThreads
  },
  props: {
    allCouriers: {
      type: Array,
      default: () => []
    },
    baseData: {
      type: Object,
      default: null
    },
    companyCountryConfig: {
      type: Object,
      required: true
    },
    orderByTags: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modalData: {},
      assignList: [],
      eventsIcons: {
        rain: {
          src: icon(faCloudRain, {
            transform: {
              size: 22
            },
            classes: ['mx-2']
          }).html
        }
      }
    }
  },
  watch: {
    'modalData.data.id': {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.updateAssignList()
        }
      },
      deep: true
    }
  },
  methods: {
    show(data) {
      if (data.normalize) {
        data = this.normalizeShipping(data)
      }
      this.modalData = {
        type: data.cardType,
        data
      }
      this.$refs.modalVisitsOverview.show()
    },
    onHide() {
      this.modalData = {}
    },
    updateAssignList() {
      if (!this.modalData.data) return

      const assignList = [...this.allCouriers]
      const startGeo = {
        lat: Number.parseFloat(this.modalData.data.visits4Show ? this.modalData.data.visits4Show[0].lat : this.modalData.data.from_lat),
        lng: Number.parseFloat(this.modalData.data.visits4Show ? this.modalData.data.visits4Show[0].lng : this.modalData.data.from_lng)
      }
      for (const courier of assignList) {
        if (courier.tracking && courier.tracking[0]) {
          courier.distance = this.getDistance(startGeo, {
            lat: Number.parseFloat(courier.tracking[0].lat),
            lng: Number.parseFloat(courier.tracking[0].lng)
          })
        } else {
          courier.distance = Infinity
        }
      }
      this.assignList = assignList.sort((a, b) => a.distance - b.distance)
    },
    normalizeShipping(shipping, isShared = false) {
      const eventsIcons = shipping.events ? shipping.events.event_names : null
      return shipping.address_from && shipping.address_to
        ? {
            id: shipping.id,
            isShared: shipping.isShared,
            cardType: 'shipping',
            courier: shipping.courier || null,
            from_contact: shipping.from_contact,
            from_address: shipping.address_from.formatted_address,
            from_meta: shipping.from_meta,
            to_contact: shipping.to_contact,
            to_address: shipping.address_to.formatted_address,
            to_meta: shipping.to_meta,
            from_lat: shipping.address_from.lat,
            from_lng: shipping.address_from.lng,
            to_lat: shipping.address_to.lat,
            to_lng: shipping.address_to.lng,
            status: shipping.status,
            is_back_and_forth: shipping.is_back_and_forth,
            commission: !shipping.events ? Number.parseFloat(shipping.courier_commission).toLocaleString(this.companyCountryConfig.i18n.lang.replaceAll('_', '-'), { style: 'currency', currency: this.companyCountryConfig.i18n.currency }) : '<strike>' + Number.parseFloat(shipping.courier_commission).toLocaleString(this.companyCountryConfig.i18n.lang.replaceAll('_', '-'), { style: 'currency', currency: this.companyCountryConfig.i18n.currency }) + '</strike> ' + this.renderIcons(eventsIcons) + Number.parseFloat(shipping.events.total_commission).toLocaleString(this.companyCountryConfig.i18n.lang.replaceAll('_', '-'), { style: 'currency', currency: this.companyCountryConfig.i18n.currency }),
            commissionRaw: Number.parseInt(shipping.courier_commission),
            type: this.shippingTypesShared.find(x => x.value === shipping.shipping_type_id).text,
            size: this.shippingSizes.find(x => x.id === shipping.size_id)?.name || 'no-size',
            distance: this.baseData
              ? this.getDistance(this.baseData, {
                lat: shipping.address_from.lat,
                lng: shipping.address_from.lng
              })
              : 0,
            total_distance: this.getDistance({
              lat: shipping.address_from.lat,
              lng: shipping.address_from.lng
            }, {
              lat: shipping.address_to.lat,
              lng: shipping.address_to.lng
            }),
            tags: shipping.tags,
            items: shipping.items && shipping.items.length > 0 ? shipping.items : [],
            order: this.shippingOrder(shipping),
            threads: shipping.threads,
            meta: shipping.meta,
            shipping
          }
        : {}
    },
    shippingOrder(shipping) {
      const from = { lat: shipping.address_from.lat, lng: shipping.address_from.lng }
      if (this.orderByTags && (!shipping.tags || shipping.tags.length === 0)) {
        return this.baseData ? this.getDistance(this.baseData, from) + 100000 : 100000
      }
      return this.baseData ? this.getDistance(this.baseData, from) : 0
    },
    renderIcons(eventIcons) {
      let html = ''
      if (!eventIcons) return html
      for (const icon of eventIcons) {
        html += this.eventsIcons[icon] ? this.eventsIcons[icon].src : ''
      }
      return html
    },
    assignCourier(el, courier) {
      let translate
      if (el.type === 'shipping') {
        translate = this.$gettext('Are you sure you want to assign the shipment with ID #%{shippingId} to %{courierName}?')
        if (confirm(this.$gettextInterpolate(translate, { shippingId: this.$options.filters.uuid(el.data.id), courierName: courier.user.name })) === true) {
          const params = {
            shipping_id: el.data.id,
            user_id: courier.user.id,
            status: 'CONFIRMED'
          }
          this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
            .then(response => {
              this.$refs.modalVisitsOverview.hide()
              this.$emit('assigned')
            }, error => {
              let obj = {}
              if (error.status === 409) {
                obj = {
                  title: 'ERROR',
                  message: this.$gettext('Sorry! The shipping has been taken by other courier before.'),
                  type: 'error',
                  customCloseBtnText: this.$gettext('Close')
                }
              } else {
                obj = {
                  title: 'ERROR',
                  message: this.$gettext('There were unexpected errors. Please try again.'),
                  type: 'error',
                  customCloseBtnText: this.$gettext('Close')
                }
              }
              this.$root.$children[0].$refs.simplert.openSimplert(obj)
              this.$refs.modalVisitsOverview.hide()
              this.$emit('assigned')
            })
        }
      } else {
        translate = this.$gettext('Are you sure you want to assign the tour with ID #%{tourId} to %{courierName}?')
        if (confirm(this.$gettextInterpolate(translate, { tourId: this.$options.filters.uuid(el.data.id), courierName: courier.user.name })) === true) {
          this.$http.patch(this.$appConfig.api.baseUrl + 'tours/' + el.data.id, { courier_id: courier.user.id })
            .then(response => {
              this.$refs.modalVisitsOverview.hide()
              this.$emit('assigned')
            }, error => {
              let obj = {}
              if (error.status === 409) {
                obj = {
                  title: 'ERROR',
                  message: this.$gettext('Sorry! The Tour has been taken by other courier before.'),
                  type: 'error',
                  customCloseBtnText: this.$gettext('Close')
                }
              } else {
                obj = {
                  title: 'ERROR',
                  message: this.$gettext('There were unexpected errors. Please try again.'),
                  type: 'error',
                  customCloseBtnText: this.$gettext('Close')
                }
              }
              this.$root.$children[0].$refs.simplert.openSimplert(obj)
              this.$refs.modalVisitsOverview.hide()
              this.$emit('assigned')
            })
        }
      }
    }
  }
}
</script>

<style scoped>
.profile-image {
  background-size: cover;
  background-position: center;
}
.big .badge {
  font-size: 1.2rem;
}
.card-benefit {
  font-weight: bold;
}
</style>
